// @ts-nocheck
import { useState, useMemo, useEffect } from 'react'
import clsx from 'clsx'
import s from './wxQrCode.module.scss'

interface IWxQrCodeState {

}

interface IWxQrCodeProps {
  className?: string
  config: {
    appid: string
    scope: string
    redirect_uri: string
    style: string
    stylelite: number
  }
}

/** 微信二维码生成模块 */
export function WxQrCode(props: IWxQrCodeProps) {

  const { config, isBintang } = props

  const [] = useState<IWxQrCodeState>()

  useEffect(() => {
    const { appid, scope, redirect_uri, style, stylelite, href } = config
    const obj = new WxLogin({
      self_redirect: false,
      id:            'myLoginWXQrCode',
      appid:         appid,
      scope:         scope,
      // 重定向地址，需要进行UrlEncode
      // redirect_uri:  encodeURIComponent('https://eone.fjmu.edu.cn/oauth2/authorize?response_type=code&client_id=ykd&state=2a17eb2a65aa4c3199bac9b24abad24d&redirect_uri=https%3A%2F%2Feone.fjmu.edu.cn%2Fweb%2F&isBintang=0&isWeChat=1'),
      redirect_uri:  encodeURIComponent(location.href + `&isBintang=${isBintang ? 1 : 0}` + '&isWeChat=1'),
      style:         style,
      stylelite:     stylelite,
      href:          href
    })
  }, [ isBintang ])

  return (
    <div className={clsx(s.root, props.className)}>
      <div id='myLoginWXQrCode' className={s.wxQrCode} />
    </div>
  )
}